import * as React from "react";
import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "./LoginComponent.css";
import { audience, scope, domain, clientId, API_BASE_URL, SetKey, GetKey } from "../../config/config";
import { BACKEND_ERROR_MAP, LOCALSTORAGE_KEYS} from '../../utils/Constants';
import { fetchAccessToken , getStorageItem, SetStorageItem} from '../../helpers/helpers'
import { useDispatch, useSelector } from "react-redux";
import { clearMatters, fetchAllMatters } from "../Redux/matterSlice";
import { AppDispatch, RootState } from "../Redux/store";
import { createPkcePair } from "../../services/pkce";
import { establishSession, setAccessTokenDirect, setRecoveryUserId, getDecodedAccessToken } from "../../services/tokenManager";

interface SuccessPageBodyProps {
	handleAuth: (data: boolean) => void;
	// other props...
}
const LoginComponent: React.FC<SuccessPageBodyProps> = ({ handleAuth }) => {
	const {
		loginWithPopup,
		//loginWithRedirect,
		getIdTokenClaims,
		getAccessTokenSilently,
		logout,
		user,
		isAuthenticated,
	} = useAuth0();

	const [GetAuthenticated, setAuthenticated] = useState(false);
	//const [dialog, setDialog] = useState(null); // Store dialog instance
	const [platform, setplatform] = useState('win');
	const [outlookmode, setoutlookmode] = useState('nowwin');

	const [profileEmail, SetEmail] = useState("");
	const dispatch = useDispatch<AppDispatch>();
	const matters = useSelector((state: RootState) => state.matters);
	let dialog = null;
	let profile = "";
	let pkceVerifier: string | null = null; // set in handleLogin's classic-Outlook branch, read in processAuthCode

	const handleClear = () => {
		dispatch(clearMatters());
		// Wait a tick to let state update
		setTimeout(() => {
			console.log("State after clearing:", matters);
		}, 10);
	};
	
function checkOutlookEnvironmentLegacy() {
		var isOutlookMacDesktop = false;
		const host = Office.context.mailbox.diagnostics.hostName;
		const platform = Office.context.platform;
		//const version = Office.context.;
		if (Office.context.mailbox) {
			let diagnostics = Office.context.mailbox.diagnostics;
		    profile = Office.context.mailbox.userProfile.emailAddress;
			console.log("checkOutlookEnvironment " + profile);
			SetEmail(profile);
			//console.log("profileEmail " + profile);

			// Determine the host application
			let hostName = diagnostics.hostName; // e.g., "Outlook" or "OutlookWebApp"
			let hostVersion = diagnostics.hostVersion; // e.g., "16.0.12345.67890"
			let platform = Office.context.platform; // e.g., "PC", "Mac", "OfficeOnline"

			// Logic based on environment
			if (hostName === "OutlookWebApp" && platform === Office.PlatformType.OfficeOnline) {
				//console.log("Running in browser (Outlook on the web).");
				setplatform("Browser " + hostName)
			} else if (hostName === "Outlook" && isMacDesktop()) {
				isOutlookMacDesktop = true;
				setplatform("Mac outlook Desktop " + hostName)
				setoutlookmode("win")
				//console.log("Running in Mac desktop client.");
				return isOutlookMacDesktop;
			}
			else if(hostName === "newOutlookWindows" && !isMacDesktop())
			{
				isOutlookMacDesktop = true;
				setplatform("Window outlook Desktop")
				setoutlookmode("win")
				return isOutlookMacDesktop;
				//console.log("Running in Window desktop client.");
			}
			else {
				setplatform("outlook " + hostName);
			}
		}
		return isOutlookMacDesktop;
	}

	function checkOutlookEnvironment() {
    var isOutlookMacDesktop = false;

    if (Office.context.mailbox) {
        const diagnostics = Office.context.mailbox.diagnostics;
        const hostName = diagnostics.hostName;
        const hostVersion = diagnostics.hostVersion;
        const platform = Office.context.platform;

        profile = Office.context.mailbox.userProfile.emailAddress;
        SetEmail(profile);

        // Logic based on environment
        if (hostName === "OutlookWebApp" && platform === Office.PlatformType.OfficeOnline) {
            // Running in browser (Outlook on the web)
            setplatform("Browser " + hostName);
        }
        else if (hostName === "Outlook" && isMacDesktop()) {
            // Running in Mac desktop client
            isOutlookMacDesktop = true;
            setplatform("Mac outlook Desktop " + hostName);
            setoutlookmode("win");
            return isOutlookMacDesktop;
        }
        else if (hostName === "newOutlookWindows" && !isMacDesktop()) {
            // Running in Windows desktop client
            isOutlookMacDesktop = true;
            setplatform("Window outlook Desktop");
            setoutlookmode("win");
            return isOutlookMacDesktop;
        }
        else {
            setplatform("outlook " + hostName);
        }
    }

    return isOutlookMacDesktop;
}
	function isMacDesktop() {
		return /Macintosh|MacIntel|MacPPC|Mac68K/.test(navigator.platform);
	}


	//let dialogsss = null;
	const handleLogin = async () => {
		handleClear()
		try {
			// Capture this once: checkOutlookEnvironment() calls setoutlookmode(),
			// but React state updates aren't visible synchronously within this
			// same function call, so reading the `outlookmode` state variable
			// later in this same handleLogin invocation (below) would still see
			// its stale pre-call value. Using the return value directly avoids
			// that - see the isClassicOutlookDesktop check further down.
			const isClassicOutlookDesktop = checkOutlookEnvironment();
			console.log("isClassicOutlookDesktop", isClassicOutlookDesktop);
			if (!isClassicOutlookDesktop) {
				const result = await loginWithPopup({
					authorizationParams: {
						scope: "openid profile email offline_access https://graph.microsoft.com/User.Read",
						redirect_uri: window.location.origin + "/assets/callback.html",
						audience: audience,
						login_hint: profileEmail,
						// `prompt: "login"` removed deliberately. It tells Auth0 to
						// ignore any existing SSO session and demand credentials on
						// EVERY attempt, which is what turned one failed silent
						// renewal into repeated manual logins. Without it a live
						// Auth0 session completes the popup immediately; a user with
						// no session is still prompted exactly as before.
					}
				});
				// 3. Optionally, get access token for APIs. Note: auth0-react manages
				// this token (and its own refresh token) internally and never exposes
				// the raw refresh token to app code, so this path relies on the SDK's
				// own silent-renewal rather than the server-brokered AuthSession flow
				// used by the classic-Outlook branch below.
				await getAccessTokenSilently();
			}
			else {
				var origin = window.location.origin + "/assets/callback.html";
				const pkce = createPkcePair();
				pkceVerifier = pkce.codeVerifier;
				// Every dynamic value must be URL-encoded - redirect_uri/audience
				// are full URLs (colons/slashes) and scope contains literal
				// spaces plus a nested URL. Left raw, this can produce a
				// malformed /authorize request (Auth0 redirect_uri mismatch, or
				// Office.js's displayDialogAsync silently failing to open the
				// dialog at all) - meaning establishSession() never gets reached.
				const authurl =
					`https://${domain}/authorize?client_id=${encodeURIComponent(clientId)}` +
					`&response_type=code` +
					`&code_challenge=${encodeURIComponent(pkce.codeChallenge)}` +
					`&code_challenge_method=${encodeURIComponent(pkce.codeChallengeMethod)}` +
					`&redirect_uri=${encodeURIComponent(origin)}` +
					`&audience=${encodeURIComponent(audience)}` +
					`&scope=${encodeURIComponent("openid profile email offline_access https://graph.microsoft.com/User.Read")}`;
				Office.context.ui.displayDialogAsync(
					authurl,
					{ height: 72, width: 28 },
					function (result) {
						if (result.status === Office.AsyncResultStatus.Failed) {
							console.error("Failed to open dialog:", result.error.message);
						} else {
							dialog = result.value;

							// Step 2: Listen for messages from the dialog
							dialog.addEventHandler(
								Office.EventType.DialogMessageReceived,
								processAuthCode
							);

							// Handle dialog closed events
							dialog.addEventHandler(
								Office.EventType.DialogEventReceived,
								() => {
									console.log("Dialog was closed.")
								}
							);

						}
					}
				);
			}
			if (!isClassicOutlookDesktop) {
				const token = await getAccessTokenSilently();
				ProcessToken(token);
			}

		} catch (error) {
			console.error("Login failed:", error);
		}
	};
	async function ProcessToken(token){
			if (token != null) {
				// Access token itself is no longer written to localStorage - hand it
				// to tokenManager's in-memory store instead, so apiClient has
				// something to attach to requests for this (modern-host,
				// auth0-react-managed) login path. tokenManager.registerSilentRefresh
				// (wired up once in App.tsx) covers renewing it later.
				setAccessTokenDirect(token);

				// MARKER: START-SESSION-RECOVERY-FIX
				// Store user ID for session recovery (modern host path)
				const decoded = getDecodedAccessToken();
				console.log("[LoginComponents] DEBUG: decoded token =", decoded);
				if (decoded && typeof (decoded as any).sub === 'string') {
					const userId = (decoded as any).sub;
					setRecoveryUserId(userId);
					console.log("[LoginComponents] ✓ Recovery user ID stored:", userId);
				} else {
					console.log("[LoginComponents] ✗ Could not extract user ID from token");
				}
				// MARKER: END-SESSION-RECOVERY-FIX

				if (Office.context.mailbox) {
					let userProfile = Office.context.mailbox.userProfile;
					SetStorageItem(LOCALSTORAGE_KEYS.LoggedProfile, userProfile.emailAddress)
				}
				setAuthenticated(true);
				handleAuth(true)
			}
	}
	async function processAuthCode(args) {
		const code = args.message; // authorization code sent from the dialog - never a token
		if (code && pkceVerifier) {
			try {
				await establishSession({
					code,
					codeVerifier: pkceVerifier,
					redirectUri: window.location.origin + "/assets/callback.html",
				});

				// MARKER: START-SESSION-RECOVERY-FIX
				// Store user ID for session recovery (classic Outlook path)
				const decoded = getDecodedAccessToken();
				console.log("[LoginComponents] DEBUG: decoded token (classic) =", decoded);
				if (decoded && typeof (decoded as any).sub === 'string') {
					const userId = (decoded as any).sub;
					setRecoveryUserId(userId);
					console.log("[LoginComponents] ✓ Recovery user ID stored (classic Outlook):", userId);
				} else {
					console.log("[LoginComponents] ✗ Could not extract user ID from token (classic Outlook)");
				}
				// MARKER: END-SESSION-RECOVERY-FIX

				setAuthenticated(true);
				handleAuth(true);
			} catch (err) {
				console.error("Failed to establish session:", err);
			} finally {
				pkceVerifier = null;
				dialog.close();
				dialog = null;
			}
		}
	}


	return (
		<div>
			{/* {GetAuthenticated ? (
					<BaseComponent />
				) : ( */}
			<div className="login-container">
				<div className="login-box">
					<div style={{ textAlign: 'center', fontSize: '24px', color: '#333' }}>
						<img src='assets/icon-80.png' alt="Clarra Logo" className="logo" />
					</div>

					<h1 style={{ fontSize: '16px', color: '#4a4a4a' }}>Enable Log to Clarra App</h1>
					<p></p>
					<h1 style={{ fontSize: '14px', color: '#4a4a4a' }}>To enable logging emails to Clarra, sign in to your Clarra account.</h1>

					<button onClick={handleLogin} className="login-button">
						Sign in
					</button>
				</div>
			</div>
			{/* )} */}

		</div>
	);
};

export default LoginComponent;
